export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN;

export const baseAPIUrl = API_DOMAIN!;
